import React, { useState } from "react";
import home from "../Styles/Home.css"
import cycle from "../Assest/cycle.jpg"
import electronics from "../Assest/elec.jpg"
import books from "../Assest/books.jpg"
import more from "../Assest/more.jpg"
import { useNavigate } from "react-router-dom";

const Home = ()=> 
{
   const navigate = useNavigate();
    const handlecycles =()=>
   {
     navigate("/cycles");
   }
   const handleelec =()=>
   {
      navigate("/electronics");
   }
   const handlebooks =()=>
   {
      navigate("/books");
   }
   const handleall =()=>
   {
      navigate("/allp");
   }
    return(
        <div className="home">
         <div>
         <div  onClick={handlecycles} >
            <img src={cycle}/>
            <p>Cycles</p>
         </div>
         <div  onClick={handleelec}>
           <img src={electronics}/>
            <p>Electronics</p>
         </div>
         </div>

         <div>
         <div  onClick={handlebooks}>
         <img src={books}/>
            <p>Books</p>
         </div>
         <div  onClick={handleall}>
         <img src={more}/>
            <p>More</p>
         </div>
         </div>
        </div>
    )

}
export default Home;